export default __webpack_public_path__ + "static/media/tabuleiro.8dbe26c6.webp";